const deviceUUIDPrefix = (deviceUUID?: string) => '';

const fullPath = (path: string) => `${path}`;

export function queuesPath(deviceUUID: string) {
  return `${deviceUUIDPrefix(deviceUUID)}/queues`;
}

export function fullQueuesPath(deviceUUID?: string) {
  return fullPath(`${deviceUUIDPrefix(deviceUUID)}/queues`);
}

export function calendarPath(deviceUUID: string) {
  return `${deviceUUIDPrefix(deviceUUID)}/calendar`;
}

export function queueSettingsPath(deviceUUID: string, queueId: string) {
  return `${deviceUUIDPrefix(deviceUUID)}/queues/${queueId}/settings`;
}

export function appSettingsPath(deviceUUID?: string) {
  return `${deviceUUIDPrefix(deviceUUID)}/settings`;
}

export function providerMessagePath(deviceUUID: string) {
  return `${deviceUUIDPrefix(deviceUUID)}/provider-message`;
}
